var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { legacy } from '../../../utils/serializr/schema/outer/legacy';
import { disgardOldValue } from '../../../utils/serializr/schema/middle/disgardOldValue';
import { custom } from '../../../utils/serializr/schema/inner/custom';
import { ThinkAndRevealLegacy } from './ThinkAndRevealLegacy';
export class ThinkAndRevealStore {
    parent;
    constructor({ parent }) {
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get thinkAndRevealLegacy() {
        return new ThinkAndRevealLegacy(this);
    }
    get questionTypeLegacy() {
        return this.thinkAndRevealLegacy;
    }
    get solution() {
        return this.question.ownAspect.solution.aspectContent.local.primaryTextBasis;
    }
    set solution(t) {
        this.question.ownAspect.solution.aspectContent.local.primaryTextBasis = t;
    }
    get legacyImages() {
        return undefined;
        return this.thinkAndRevealLegacy.legacyImages;
    }
    set legacyImages(l) {
        if (!l)
            return;
        this.thinkAndRevealLegacy.legacyImages = l;
    }
    get legacyComments() {
        return undefined;
        return [];
    }
    set legacyComments(l) { }
    static get serializeInfo() {
        return {
            props: {
                solution: true,
                legacyImages: legacy(disgardOldValue(custom(a => a, a => a))),
                legacyComments: legacy(disgardOldValue(custom(a => a, a => a))),
            },
        };
    }
}
__decorate([
    memoize
], ThinkAndRevealStore.prototype, "thinkAndRevealLegacy", null);
__decorate([
    memoize
], ThinkAndRevealStore, "serializeInfo", null);
